module.exports = __webpack_public_path__ + "img/top.c5d1c697.jpg";